import { render, staticRenderFns } from "./goodsSignature.vue?vue&type=template&id=eb3a67ac&scoped=true"
import script from "./goodsSignature.vue?vue&type=script&lang=js"
export * from "./goodsSignature.vue?vue&type=script&lang=js"
import style0 from "./goodsSignature.vue?vue&type=style&index=0&id=eb3a67ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb3a67ac",
  null
  
)

export default component.exports